import styled from 'styled-components';

export const Container = styled.div`
  background-color: white;
  padding: 1.2rem;
  border-radius: 16px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: auto;
`;

export const StorageInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%
  margin-bottom: 0.5rem;
  gap: 4px;
  flex: 1;
  margin-left: 0.7rem;
`;

export const Icon = styled.div`
  margin-right: 0.5rem;
  width: 68px;
  height: 68px;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
  }
`;

export const BarContainer = styled.div`
  background-color: #e0e0e0;
  height: 8px; /* Increased height for better visibility */
  border-radius: 8px;
  width: 100%; /* Ensure container width is non-zero */
  position: relative;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  background-color: #9e60f9;
  height: 100%;
  width: ${({ width }) => width};
  transition: width 0.3s ease-in-out;
`;

export const PurpleDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: #9e60f9;
  border-radius: 50%;
  align-self: center;
`;
